import axios from "axios"
import { SERVER_URI } from "../utils/config"
import { checkToken } from "./checkToken"

export const dbinsert = async (table, data) => {
	checkToken()
	try{
		const response = await axios.post(`${SERVER_URI}/${table}/`, data)
		return response.data
	} catch (err) {
		console.error(err)
		throw new Error("Error inserting data")
	}
}
